import {
  SET_CITIES,
  SET_COUNTRIES,
  SET_CREW_ROLES,
  SET_FINISH_COUNTRIES,
  SET_FINISH_MARINAS,
  SET_LICENSE_SYSTEMS,
  SET_LICENSE_TYPES,
  SET_MARINAS,
  SET_OPERATORS,
  SET_REGIONS,
  SET_SHIPYARDS,
  SET_YACHT_MODELS,
  SET_YACHT_TYPES,
  SET_YACHTS
} from "./data-types";

const initialState = {
  marinas: [],
  finishMarinas: [],
  yachtModels: [],
  shipyards: [],
  yachtTypes: [],
  yachts: [],
  regions: [],
  countries: [],
  finishCountries: [],
  cities: [],
  crewRoles: [],
  operators: [],
  licenseSystems: [],
  licenseTypes: []
}

export const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MARINAS: return {...state, marinas: action.marinas}
    case SET_FINISH_MARINAS: return {...state, finishMarinas: action.finishMarinas}
    case SET_YACHT_MODELS: return {...state, yachtModels: action.yachtModels}
    case SET_SHIPYARDS: return {...state, shipyards: action.shipyards}
    case SET_YACHT_TYPES: return {...state, yachtTypes: action.yachtTypes}
    case SET_YACHTS: return {...state, yachts: action.yachts}
    case SET_REGIONS: return {...state, regions: action.regions}
    case SET_CITIES: return {...state, cities: action.cities}
    case SET_COUNTRIES: return {...state, countries: action.countries}
    case SET_FINISH_COUNTRIES: return {...state, finishCountries: action.finishCountries}
    case SET_CREW_ROLES: return {...state, crewRoles: action.crewRoles}
    case SET_OPERATORS: return {...state, operators: action.operators}
    case SET_LICENSE_SYSTEMS: return {...state, licenseSystems: action.licenseSystems}
    case SET_LICENSE_TYPES: return {...state, licenseTypes: action.licenseTypes}
    default: return state
  }
}
